import { inject, Injectable } from '@angular/core';
import { CanMatch, PartialMatchRouteSnapshot, Route, UrlSegment } from '@angular/router';

import { UserType } from '@reach/interfaces/user/user-type.enum';

import { SessionService } from '~app-client/core/services';

@Injectable()
export class CanAccessHomeGuard implements CanMatch {
	private readonly session = inject(SessionService);

	private async guard(): Promise<boolean> {
		await this.session.untilLoadingFinished();

		if (!this.session.triedToLogin) {
			try {
				await this.session.ping();
			} catch {
				//
			}
		}

		const { user } = this.session;

		if (user?.type === UserType.ALPHA) {
			return true;
		}

		return false;
	}

	async canMatch(
		_route: Route,
		_segments: UrlSegment[],
		_currentSnapshot: PartialMatchRouteSnapshot
	): Promise<boolean> {
		const ret = await this.guard();
		return ret;
	}
}
